import React from "react";

// Square gradient CR monogram (icon-only) — used for favicon / compact contexts.
export function LogoMark({ className = "w-9 h-9" }) {
  return (
    <img src="/logo-icon.png" alt="Coach Reyland" className={`${className} rounded-[22%] object-contain`} />
  );
}

// Full horizontal lockup by default; icon-only when compact.
export function LogoLockup({ compact = false }) {
  if (compact) {
    return <img src="/logo-icon.png" alt="Coach Reyland VA Learning Platform" className="h-9 w-9 rounded-[22%] object-contain" />;
  }
  return <img src="/logo-full.png" alt="Coach Reyland VA Learning Platform" className="h-9 sm:h-10 w-auto object-contain" />;
}
